import { lifecycle } from 'recompose';

export default (name, requireFn) =>
  lifecycle({
    async componentDidMount() {
      const mocks = requireFn();
      this.setState({ [name]: mocks });
    },
  });
